import type { DailyGoalHistoryDay } from "@consistency-circle/shared";

import { Progress } from "@/components/ui/progress";
import { todayString } from "../../../lib/goal-stats";

export function DayCard({ day }: { readonly day: DailyGoalHistoryDay }) {
  const date = new Date(`${day.localDate}T00:00:00`);
  const formatted = new Intl.DateTimeFormat("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  }).format(date);
  const isToday = day.localDate === todayString();

  return (
    <div className="space-y-2.5 rounded-xl border border-border bg-card p-4">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium">
          {formatted}
          {isToday && <span className="ml-2 text-xs font-medium text-primary">Today</span>}
        </span>
        <span
          className={`text-sm font-semibold tabular-nums ${
            day.completionPercent === 100
              ? "text-green-600 dark:text-green-400"
              : day.completionPercent > 0
                ? "text-primary"
                : "text-muted-foreground"
          }`}
        >
          {day.totalCount === 0 ? "-" : `${day.completionPercent}%`}
        </span>
      </div>
      {day.totalCount > 0 ? (
        <>
          <Progress value={day.completionPercent} className="h-1.5" />
          <p className="text-xs text-muted-foreground">
            {day.completedCount} of {day.totalCount} completed
            {day.skippedCount > 0 && ` - ${day.skippedCount} skipped`}
          </p>
        </>
      ) : (
        <p className="text-xs text-muted-foreground">No goals tracked</p>
      )}
    </div>
  );
}
